import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

export default function LogPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  function load() {
    fetch(`${API_BASE_URL}/api/logs?limit=60`)
      .then(r => r.json())
      .then(d => { setLogs(d); setLoading(false); })
      .catch(() => setLoading(false));
  }

  async function clearLogs() {
    if (!window.confirm('Clear all logs?')) return;
    await fetch(`${API_BASE_URL}/api/logs`, { method: 'DELETE' });
    setLogs([]);
  }

  function fmtTime(t) {
    return new Date(t).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div>
          <div className="page-title">Activity Log</div>
          <div className="page-sub">All alert events across T1 &amp; T2</div>
        </div>
        {logs.length > 0 && (
          <button className="btn-secondary" onClick={clearLogs} style={{ padding: '6px 12px', fontSize: 12 }}>Clear</button>
        )}
      </div>

      {loading
        ? <div className="spinner" />
        : logs.length === 0
        ? <div className="empty-state"><div className="empty-icon">📋</div><div>No activity recorded yet</div></div>
        : (
          <div className="log-box">
            {logs.map((l, i) => (
              <div className="log-row" key={i}>
                <div>
                  <span className={l.action === 'ON' ? 'log-on' : 'log-off'}>{l.workshop} {l.action}</span>
                  {l.operator && <span className="log-op">· {l.operator}</span>}
                  <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 1 }}>
                    Payload: <code style={{ background: '#f0f4f8', padding: '0 3px', borderRadius: 3 }}>{l.payload}</code>
                    {' '}· Topic: {l.topic}
                  </div>
                </div>
                <span className="log-time">{fmtTime(l.time)}</span>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
